import _slicedToArray from '@babel/runtime-corejs3/helpers/esm/slicedToArray';
import _Object$fromEntries from '@babel/runtime-corejs3/core-js-stable/object/from-entries';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$entries from '@babel/runtime-corejs3/core-js-stable/object/entries';
import isPropValid from '@emotion/is-prop-valid';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import warning$2 from 'warning';
import _trimInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/trim';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
var regexpData$1 = /^data-/;

function filterDataAttributes(obj) {
  var _context;

  return _Object$fromEntries(_filterInstanceProperty(_context = _Object$entries(obj)).call(_context, function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        propFromEntry = _ref2[0];

    return regexpData$1.test(propFromEntry);
  }));
}

var regexpData = /^aria-/;

function filterAriaAttributes(obj) {
  var _context;

  return _Object$fromEntries(_filterInstanceProperty(_context = _Object$entries(obj)).call(_context, function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        propFromEntry = _ref2[0];

    return regexpData.test(propFromEntry);
  }));
}

function filterInvalidAttributes(obj) {
  var _context;

  return _Object$fromEntries(_filterInstanceProperty(_context = _Object$entries(obj)).call(_context, function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        propFromEntry = _ref2[0];

    return isPropValid(propFromEntry);
  }));
} // Given a string, validates that it has the correct format
// to be a number, with decimal separators and negative sign.


function isNumberish(number) {
  return !/[^(\-?)\d,.\s]/.test(number);
}

function warnDeprecatedComponent(componentName) {
  var _context;

  var additionalMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var message = _concatInstanceProperty(_context = "\"".concat(componentName, "\" has been deprecated and will be removed in the next major version.")).call(_context, additionalMessage);

  process.env.NODE_ENV !== "production" ? warning$2(false, message) : void 0;
}

function warnDeprecatedProp(propName, componentName) {
  var _context, _context2;

  var additionalMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var message = _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "\"".concat(propName, "\" property of \"")).call(_context2, componentName, "\" has been deprecated and will be removed in the next major version.")).call(_context, additionalMessage);

  process.env.NODE_ENV !== "production" ? warning$2(false, message) : void 0;
} // Whenever a field requires a unique id, this factory can be used
// to create a function returning unique ids.
//
// Use it as
//  const sequentialId = createSequentialId('text-field-');
//  const element = <div id={sequentialId()}>foo</div>


function createSequentialId(prefix) {
  var id = 0;
  return function () {
    var _context;

    id += 1;
    return _concatInstanceProperty(_context = "".concat(prefix)).call(_context, id);
  };
}

var getFieldId = function getFieldId(props, state, createId) {
  return props.id || state.id || createId();
};

var getFieldId$1 = getFieldId; // Attempts to parse a string containing a time in either 12h or 24h format,
// with precision of up to three milliseconds
// Valid inputs:
//   13:00
//   3:00
//   3 PM
//   14:5 am
//   13:00:00.000
//   13:00:60
//   13:00:59.908
// Returns an object containing
//   { hours, minutes, seconds, milliseconds }
// or null
// eslint-disable-next-line import/prefer-default-export

var parseTime = function parseTime(rawTime) {
  if (!rawTime || typeof rawTime !== 'string') return null;

  var time = _trimInstanceProperty(rawTime).call(rawTime).toLowerCase();

  var match = time.match(/^(\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:\.(\d{1,3}))?)?)?\s*(am|pm)?$/);
  if (!match) return null; // As we accept eg "3 AM" there might not be a value for minutes, seconds or
  // milliseconds, so we default them

  var _match = _slicedToArray(match, 6),
      hours = _match[1],
      minutes = _match[2],
      seconds = _match[3],
      milliseconds = _match[4],
      amPm = _match[5];

  var parsedMinutes = Number(minutes !== null && minutes !== void 0 ? minutes : '00');
  var parsedSeconds = Number(seconds !== null && seconds !== void 0 ? seconds : '00'); // Parses the number as a fraction to ensure that .5, .05 and .005 are
  // parsed correctily (they are 500, 50 and 5 respectively).

  var parsedMilliseconds = Number("0.".concat(milliseconds !== null && milliseconds !== void 0 ? milliseconds : '000')) * 1000; // edge-case: allow 24:00, but nothing over it

  var parsedHours = Number(hours) === 24 && parsedMinutes === 0 && parsedSeconds === 0 && parsedMilliseconds === 0 ? 0 : Number(hours);

  if (amPm) {
    if (parsedHours > 12) return null;
    if (parsedHours === 0) return null;
    if (parsedMinutes > 59) return null;
  } else {
    if (parsedHours > 23) return null;
    if (parsedMinutes > 59) return null;
  }

  if (parsedSeconds > 59) return null;
  if (parsedMilliseconds > 999) return null; // 12 pm (just like 24:00) would be on the next day, so we treat it as an
  // invalid value to avoid edge cases like the day jumping forward
  // if (amPm === 'pm' && Number(hours) === 12) return null;

  var hourOffset = function () {
    if (amPm === 'am' && parsedHours === 12) return -12;
    if (amPm === 'am') return 0;
    if (amPm === 'pm' && parsedHours !== 12) return 12;
    return 0;
  }();

  return {
    hours: parsedHours + hourOffset,
    minutes: parsedMinutes,
    seconds: parsedSeconds,
    milliseconds: parsedMilliseconds
  };
};

var parseTime$1 = parseTime; // eslint-disable-next-line import/prefer-default-export

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var SafeHTMLElement = canUseDOM ? window.HTMLElement : {};
var SafeHTMLElement$1 = SafeHTMLElement;

function addStaticFields(Component, fields) {
  var _context;

  _forEachInstanceProperty(_context = _Object$entries(fields)).call(_context, function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1]; // eslint-disable-next-line no-param-reassign
    // @ts-expect-error


    Component[key] = value;
  });

  return Component;
} // To avoid getting the following error, we type the entire function.
//   "Assertions require every name in the call target to be declared with an explicit type annotation."
// See https://github.com/microsoft/TypeScript/pull/33622#issuecomment-575301357


var isProduction = process.env.NODE_ENV === 'production'; // @TODO: allow consumer to set the prefix e.g `[ Text.Body ]`

var prefix = 'Warning'; // Throw an error if the condition fails
// Strip out error messages for production
// > Not providing an inline default argument for message as the result is smaller

var warning = function warning(condition, message) {
  if (isProduction) {
    return;
  }

  if (condition) {
    return;
  } // Condition not passed
  // When not in production we allow the message to pass through
  // *This block will be removed in production builds*


  throw new Error("".concat(prefix, ": ").concat(message || ''));
};

var warning$1 = warning; // NOTE: This string will be replaced on build time with the package version.

var version = "12.2.9";
export { SafeHTMLElement$1 as SafeHTMLElement, addStaticFields, canUseDOM, createSequentialId, filterAriaAttributes, filterDataAttributes, filterInvalidAttributes, getFieldId$1 as getFieldId, isNumberish, parseTime$1 as parseTime, version, warnDeprecatedComponent, warnDeprecatedProp, warning$1 as warning };